import React, {
  Suspense,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import useAuth, { IAuthResult } from '../hooks/useAuth';
import useSplitInit from '../hooks/useSplitInit';
// import FullScreenLoader from '../components/FullScreenLoader';
// import CategoryViewPageShimmerState from '../components/CategoryViewPageShimmerState';
// import { CardButtonSkeletonLoader } from 'ui/mobile-ds';
const AppRouter = React.lazy(() => import('../Router'));

const AuthContext = createContext<IAuthResult>({
  isAppReady: false,
  isTokenAdded: false,
  setIsTokenAdded: () => {},
  setUser: () => {},
  user: null,
  token: null,
});

const AuthProvider = () => {
  const { isAppReady, isTokenAdded, setIsTokenAdded, setUser, user, token } =
    useAuth();

  useSplitInit(user?.organisationId);

  const [isChatWithPolicyEnabled, setIsChatWithPolicyEnabled] = useState(true);

  const values = useMemo(
    () => ({
      isAppReady,
      isTokenAdded,
      setIsTokenAdded,
      setUser,
      user,
      token,
      isChatWithPolicyEnabled,
      setIsChatWithPolicyEnabled,
    }),
    [
      isAppReady,
      isTokenAdded,
      setIsTokenAdded,
      setUser,
      user,
      token,
      isChatWithPolicyEnabled,
      setIsChatWithPolicyEnabled,
    ],
  );

  useEffect(() => {
    // only allow smartlook records for prod
    if (import.meta.env.PROD) {
      //   window?.smartlook('init', 'ae7f1dffebddf76a8c07c241ecf97874b830f0b8', {
      //     region: 'eu',
      //   });
      window?.smartlook?.('init', '68758f39546798d8834a67fa8aadfb06c05b9c03', {
        region: 'eu',
      });
      window?.smartlook('identify', user?.memberId as string, {
        memberId: user?.memberId,
        organisationId: user?.organisationId,
        email: user?.emailId,
      });
    }
  }, [user?.emailId, user?.organisationId, user?.memberId]);

  if (!isAppReady && !token) {
    return null;
    // return <FullScreenLoader />;
  }

  return (
    <AuthContext.Provider value={values}>
      <Suspense>
        <AppRouter />
      </Suspense>
    </AuthContext.Provider>
  );
};

const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('Need a auth context!');
  }
  return context;
};

export default AuthProvider;
export { useAuthContext, AuthContext };
